var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSend2 = function SvgSend2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42351 11.9999L13.3093 14.4629C13.425 14.5045 13.5485 14.5197 13.6708 14.5074C13.7931 14.4951 13.9111 14.4556 14.0162 14.3919C14.1213 14.3281 14.2108 14.2417 14.2782 14.1389C14.3456 14.0361 14.3892 13.9195 14.4058 13.7977L15.8105 3.17918C15.896 2.53268 15.2263 2.05043 14.6353 2.33168L1.28601 8.70368C0.626014 9.01868 0.675514 9.97118 1.36551 10.2164L3.19551 10.8674L4.19301 11.2177M9.06801 12.9449L7.57551 15.4394C7.08801 16.0454 6.10626 15.7027 6.10626 14.9272V12.9299C6.10629 12.553 6.2482 12.19 6.50376 11.9129L9.40701 8.76293",
    stroke: "white",
    strokeWidth: 1.14545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSend2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "send2.a97aefe2bca113e0c6c2719fe82add5d.svg";